"use strict";

import axios from "axios";
var moment = require("moment");
//const url = "https://api.elcoma.com.br/api";
//let axiosInterceptor = null

export default class Webservices {
  debug_ws = false;

  constructor() {}

  /*   getUrl() {
    return "https://api.elcoma.com.br/api";
  } */

  /*   getUrl() {
    return "https://api-staging.vagalumewifi.com.br/api";
  } */

  getUrl() {
    return "https://api-h.vagalumewifi.com.br/api";
  }

  getUrlStaging() {
    return "https://api-h.vagalumewifi.com.br/api";
  }

  getUrlController() {
    return "https://api-controller-h.vagalumewifi.com.br";
  }

  getUrlStagingTeste() {
    return "https://api-staging.vagalumewifi.com.br/api";
  }
  setToken(token) {
    if (this.debug_ws) {
      console.log(token);
    }
    axios.defaults.headers.common["Authorization"] = token;
  }

  getToken() {
    return axios.defaults.headers.common["Authorization"];
  }

  removeToken() {
    delete axios.defaults.headers.common["Authorization"];
  }

  captchaLogin(credentials) {
    return new Promise((resolve, reject) => {
      axios
        .post(this.getUrl() + "/acks/captchaLogin/", {
          username: credentials.username,
          password: credentials.password,
          response: credentials.response
        })
        .then(response => {
          if (response.data.success) {
            axios.defaults.headers.common["Authorization"] = response.data.id;
          }
          resolve(response);
        })
        .catch(error => {
          if (error.status) {
            //console.log(error.status)
          }
          //console.log(error)
          reject(error);
        });
    });
  }

  /* videos */
  uploadVideo(formData) {
    let action = "uploadVideo";
    let payload = { formData: formData };
    let endpoint = "POST /videos/noos-videos/upload";
    let status;

    let clientControllerId = JSON.parse(localStorage.getItem("data")).client
      .controller_id;

    try {
      var response = axios.post(
        this.getUrl() + "/videos/noos-videos/upload",
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data"
          }
        }
      );
      status = { status: "success" };
      this.logInteraction(
        action,
        payload,
        endpoint,
        status,
        "",
        clientControllerId,
        ""
      );
      return response;
    } catch (e) {
      status = { status: "fail", detail: e };
      this.logInteraction(
        action,
        payload,
        endpoint,
        status,
        "",
        clientControllerId,
        ""
      );
    }

    // return axios.post(this.getUrl() + "/videos/noos-videos/upload", formData, {
    //   headers: {
    //     "Content-Type": "multipart/form-data"
    //   }
    // });
  }

  getQuestionsByGroup(group_id) {
    //TODO revisar e corrigir rotas com grupo
    return axios.get(
      `${this.getUrl()}/questions?filter={"where":{"group_id":{"like":"${group_id}"}}}`
    );
  }

  async updateQuestionGroup(data) {
    var questions = (
      await axios.get(
        `${this.getUrl()}/questions/?filter={"where":{"question_group_id":"${
          data.question_group_id
        }"}}`
      )
    ).data;

    var data_ = Object.assign({}, data);

    for (var i = 0; i < questions.length; i++) {
      var question = questions[i];

      data_["client_id"] = question.client_id;
      data_["company_id"] = question.company_id;
      data_.id = question.id;

      await this.updateQuestion(data_);
    }
  }

  async updateVideoManifestGroup(data) {
    var videos = (
      await axios.get(
        `${this.getUrl()}/videoManifests/?filter={"where":{"video_group_id":"${
          data.video_group_id
        }"}}`
      )
    ).data;

    var data_ = Object.assign({}, data);

    for (var i = 0; i < videos.length; i++) {
      var video = videos[i];

      data_["client_id"] = video.client_id;
      data_.id = video.id;

      await this.updateVideoManifest(data_);
    }
  }

  getVideosByGroup(group_id) {
    return axios.get(
      `${this.getUrl()}/  s?filter={"where":{"group_id":{"like":"${group_id}"}}, "order":"timeCreated DESC"}`
    );
  }

  /* videoManifests */
  saveVideoManifest(data) {
    let action = "saveVideoManifest";
    let payload = { data: data };
    let endpoint = "POST /videoManifests";
    let status;

    let clientControllerId = JSON.parse(localStorage.getItem("data")).client
      .controller_id;

    try {
      var response = axios.post(this.getUrl() + "/videoManifests", data);
      status = { status: "success" };
      this.logInteraction(
        action,
        payload,
        endpoint,
        status,
        "",
        clientControllerId,
        ""
      );
      return response;
    } catch (e) {
      status = { status: "fail", detail: e };
      this.logInteraction(
        action,
        payload,
        endpoint,
        status,
        "",
        clientControllerId,
        ""
      );
    }
  }
  updateVideoManifest(data) {
    let action = "updateVideoManifest";
    let payload = { data: data };
    let endpoint = `PUT /videoManifests/${data.id}`;
    let status;

    let clientControllerId = JSON.parse(localStorage.getItem("data")).client
      .controller_id;

    try {
      var response = axios.put(
        this.getUrl() + "/videoManifests/" + data.id,
        data
      );
      status = { status: "success" };
      this.logInteraction(
        action,
        payload,
        endpoint,
        status,
        "",
        clientControllerId,
        ""
      );
      return response;
    } catch (e) {
      status = { status: "fail", detail: e };
      this.logInteraction(
        action,
        payload,
        endpoint,
        status,
        "",
        clientControllerId,
        ""
      );
    }
  }
  getVideos(company_id) {
    return axios.get(
      this.getUrl() +
        '/videoManifests?filter={ "where" : { "client_id" : "' +
        company_id +
        '"}, "order":"timeCreated DESC"}'
    );
  }
  getVideo(video_id) {
    return axios.get(this.getUrl() + "/videoManifests/" + video_id);
  }
  deleteVideoManifest(data_id) {
    return axios.delete(this.getUrl() + "/videoManifests/" + data_id);
  }

  /* questions */
  saveQuestion(data) {
    let action = "saveQuestion";
    let payload = { data: data };
    let endpoint = "POST /redoneQuestions/postFullRedoneQuestion";
    let status;

    let clientControllerId = JSON.parse(localStorage.getItem("data")).client
      .controller_id;

    try {
      var response = axios.post(
        this.getUrl() + "/redoneQuestions/postFullRedoneQuestion",
        data
      );
      status = { status: "success" };
      this.logInteraction(
        action,
        payload,
        endpoint,
        status,
        "",
        clientControllerId,
        ""
      );
      return response;
    } catch (e) {
      status = { status: "fail", detail: e };
      this.logInteraction(
        action,
        payload,
        endpoint,
        status,
        "",
        clientControllerId,
        ""
      );
    }
  }
  updateQuestion(data) {
    let action = "updateQuestion";
    let payload = { data: data };
    let endpoint = "PUT /redoneQuestions/putFullRedoneQuestion";
    let status;

    let clientControllerId = JSON.parse(localStorage.getItem("data")).client
      .controller_id;

    try {
      var response = axios.put(
        this.getUrl() + "/redoneQuestions/putFullRedoneQuestion",
        data
      );
      status = { status: "success" };
      this.logInteraction(
        action,
        payload,
        endpoint,
        status,
        "",
        clientControllerId,
        ""
      );
      return response;
    } catch (e) {
      status = { status: "fail", detail: e };
      this.logInteraction(
        action,
        payload,
        endpoint,
        status,
        "",
        clientControllerId,
        ""
      );
    }
  }
  getQuestions(company_id) {
    // return axios.get(
    //   this.getUrl() +
    //   '/questions?filter={ "where" : { "company_id" : "' +
    //   company_id +
    //   '"}}'
    // );

    var data = '{ "where": { "clientID": company_id } }';

    return axios.get(
      this.getUrl() + "/redoneQuestions/getFullRedoneQuestion",
      data
    );
  }

  getDailyMediaReport(videoId, startDate, endDate) {
    return axios.get(
      `${this.getUrlController()}/daily-campaign-view/${videoId}/${startDate}/${endDate}`
    );
  }

  getTotalMediaCount(manifest_id) {
    return axios.get(
      `${this.getUrlController()}/daily-campaign-view/totalViews/${manifest_id}`
    );
  }

  getQuestionsNpsByControllerId(controller_id) {
    return axios.get(
      this.getUrl() +
        '/questions?filter={"where": { "controller_id": "' +
        controller_id +
        '"}}'
    );
  }
  postQuestionsNpsByControllerId(data) {
    return axios.post(this.getUrl() + "/questions_nps", data);
  }
  updateQuestionsNpsByControllerId(data) {
    return axios.patch(this.getUrl() + "/questions_nps/" + data.id, data);
  }
  deleteQuestionsNpsByControllerId(data_id) {
    return axios.delete(this.getUrl() + "/questions_nps/" + data_id);
  }

  deleteQuestion(data) {
    return axios.delete(
      this.getUrl() + "/redoneQuestions/deleteFullRedoneQuestion/" + data.id
    );
  }

  getQuestionWithFields(company_id) {
    /* return axios.get(
      this.getUrl() +
        '/questions?filter={ "where" : { "company_id" : "' +
        company_id +
        '"}, "fields": ["text" , "id"]}'
    ); */
    var data =
      '{ "where": { "company_id": company_id }, fields: ["text", "id"] }';
    return axios.get(
      this.getUrl() + "/redoneQuestions/getFullRedoneQuestion",
      data
    );
  }

  /* groups */
  getGroups() {
    return axios.get(this.getUrl() + "/groups");
  }

  getGroupsByFatherId(fatherId) {
    return axios.get(
      this.getUrl() +
        '/groups?filter={"fields":["id"],"where":{"father_id":{"like":"' +
        fatherId +
        '"}}}'
    );
  }

  postGroup(group) {
    return axios.post(this.getUrl() + "/groups", group);
  }

  /* clients */
  getClients() {
    return axios.get(
      this.getUrl() +
        "/clients?filter={" +
        '"fields":["name","id", "activeMap",  "idVagalox","idSwarm" ,"controller_id","coordinates", "Floors","is_active","fields","group"],' +
        '"order":"name ASC"}'
    );
  }

  getClientsByGroupId(group_id) {
    return axios.get(
      this.getUrl() +
        "/clients?filter={" +
        '"fields":["name","coordinates","Floors","id","controller_id","is_active","fields","group","activeMap","idVagalox","idSwarm","link","link_config"],' +
        '"where":{' +
        '"group.id":{' +
        '"in":["' +
        group_id +
        '"]' +
        "}" +
        "}," +
        '"order":"name ASC"' +
        "}"
    );
  }
  getClientsByGroupIdShort(group_id) {
    return axios.get(
      this.getUrl() +
        '/clients?filter={"fields":["name","id","group","radio_prefix","controller_id","link","link_config","coordinates","Floors","activeMap","idVagalox","idSwarm","link","link_config"],"where":{"group.id":{"in":["' +
        group_id +
        '"]}},' +
        '"order":"name ASC"' +
        "}"
    );
  }

  getClientsCharts(
    groupId,
    fields = [
      "name",
      "id",
      "controller_id",
      "fields",
      "radio_prefix",
      "coordinates",
      "Floors",
      "activeMap",
      "idVagalox",
      "idSwarm",
      "link",
      "link_config"
    ]
  ) {
    return new Promise(async resolve => {
      var childNodes = [];
      var buscar = [groupId];

      while (buscar.length > 0) {
        var chave = buscar.pop();

        childNodes.push(chave);

        (await this.getGroupsByFatherId(chave)).data.forEach(grupo => {
          buscar.push(grupo.id);
        });
      }

      var saida = await axios.get(
        this.getUrl() +
          '/clients?filter={"fields":[' +
          fields.map(el => '"' + el + '"').join(",") +
          '],"where":{"group.id":{"in":' +
          JSON.stringify(childNodes) +
          "}" +
          "}" +
          ',"order":"name ASC"' +
          "}"
      );

      resolve(saida);
    });
  }
  saveClient(client) {
    let action = "saveClient";
    let payload = { client: client };
    let endpoint = "POST /clients";
    let status;

    let clientControllerId = JSON.parse(localStorage.getItem("data")).client
      .controller_id;

    try {
      var response = axios.post(this.getUrl() + "/clients", client);
      status = { status: "success" };
      this.logInteraction(
        action,
        payload,
        endpoint,
        status,
        "",
        clientControllerId,
        ""
      );
      return response;
    } catch (e) {
      status = { status: "fail", detail: e };
      this.logInteraction(
        action,
        payload,
        endpoint,
        status,
        "",
        clientControllerId,
        ""
      );
    }
  }
  editClient(client) {
    let action = "editClient";
    let payload = { client: client };
    let endpoint = `PUT /clients/${client.id}`;
    let status;

    let clientControllerId = JSON.parse(localStorage.getItem("data")).client
      .controller_id;

    try {
      var response = axios.put(this.getUrl() + "/clients/" + client.id, client);
      status = { status: "success" };
      this.logInteraction(
        action,
        payload,
        endpoint,
        status,
        "",
        clientControllerId,
        ""
      );
      return response;
    } catch (e) {
      status = { status: "fail", detail: e };
      this.logInteraction(
        action,
        payload,
        endpoint,
        status,
        "",
        clientControllerId,
        ""
      );
    }
  }
  patchClient(client) {
    return axios.patch(this.getUrl() + "/clients/" + client.id, client);
  }
  deleteClient(client) {
    return axios.delete(this.getUrl() + "/clients/" + client);
  }
  getClientById(id, fields = "") {
    var query = this.getUrl() + "/clients/" + id;

    if (fields) {
      query +=
        '?filter={"fields":[' +
        fields.map(el => '"' + el + '"').join(",") +
        ', "activeMap",  "idVagalox","idSwarm","coordinates","Floors", "areas"]}';
    }

    return axios.get(query);
  }
  getAreaClientById(id) {
    return axios.get(
      this.getUrl() + "/clients/" + id + '?filter={fields:[areas]}"'
    );
  }

  /* users */
  getUsers() {
    return axios.get(
      this.getUrl() +
        '/Users?filter={"fields":["name","username","email","is_adm","client","id","group","rules"]}'
    );
  }

  getUserById(id, fields) {
    var query = this.getUrl() + "/Users/" + id;

    if (fields) {
      query +=
        '?filter={"fields":[' +
        fields.map(el => '"' + el + '"').join(",") +
        "]}";
    }

    return axios.get(query);
  }

  getUsersByGroupId(group_id) {
    return axios.get(
      this.getUrl() +
        '/Users?filter={"fields":["name","username","email","is_adm","client","id","group","rules"],"where":{"group.id":{"in":["' +
        group_id +
        '"]}}}'
    );
  }

  getUsersByClientId(client_id) {
    return axios.get(
      this.getUrl() +
        '/Users?filter={"fields":["name","username","email","is_adm","client","id","group","rules"],"where":{"client.id":{"in":["' +
        client_id +
        '"]}}}'
    );
  }

  getAreaClientById(id) {
    return axios.get(
      this.getUrl() +
        '/clients?filter={"where": {"id":"' +
        id +
        '"}, "fields":["areas"]}'
    );
  }

  saveUser(user) {
    let action = "saveUser";
    let payload = { user: user };
    let endpoint = "POST /Users";
    let status;

    let clientControllerId = JSON.parse(localStorage.getItem("data")).client
      .controller_id;

    try {
      var response = axios.post(this.getUrl() + "/Users", user);
      status = { status: "success" };
      this.logInteraction(
        action,
        payload,
        endpoint,
        status,
        "",
        clientControllerId,
        ""
      );
      return response;
    } catch (e) {
      status = { status: "fail", detail: e };
      this.logInteraction(
        action,
        payload,
        endpoint,
        status,
        "",
        clientControllerId,
        ""
      );
    }
  }
  updateUser(user) {
    let action = "updateUser";
    let payload = { user: user };
    let endpoint = `PATCH /Users/${user.id}`;
    let status;

    let clientControllerId = JSON.parse(localStorage.getItem("data")).client
      .controller_id;

    try {
      var response = axios.patch(this.getUrl() + "/Users/" + user.id, user);
      status = { status: "success" };
      this.logInteraction(
        action,
        payload,
        endpoint,
        status,
        "",
        clientControllerId,
        ""
      );
      return response;
    } catch (e) {
      status = { status: "fail", detail: e };
      this.logInteraction(
        action,
        payload,
        endpoint,
        status,
        "",
        clientControllerId,
        ""
      );
    }
  }
  deleteUser(user_id) {
    return axios.delete(this.getUrl() + "/Users/" + user_id);
  }
  async getConnectionsByClientGroupIdDates(
    clients,
    start_date,
    end_date,
    limit,
    page
  ) {
    var retorno = [];
    for (let client_id of clients) {
      var resultado = await this.getConnectionsByClientIdDates(
        client_id,
        start_date,
        end_date,
        limit,
        page
      );
      if (retorno.length != undefined) {
        retorno = resultado;
      } else {
        retorno.data = retorno.data.concat(resultado.data);
      }
    }
    return retorno;
  }
  getConnectionsByClientIdDates(client_id, start_date, end_date, limit, page) {
    var new_limit = undefined;
    var skip = undefined;
    var strUrl = "";

    if (!!limit && !!page) {
      new_limit = 3 * limit;
      skip = (page - 2) * limit;

      if (skip < 0) skip = 0;

      strUrl =
        this.getUrl() +
        "/clients/" +
        client_id +
        '/connections?filter={"include":"userAuth","where":{"datetimeauto":{"between":["' +
        moment(start_date)
          .local()
          .format() +
        '", "' +
        moment(end_date)
          .local()
          .format() +
        '"]}},"limit":' +
        new_limit +
        ',"skip":' +
        skip +
        ',"order":"datetimeauto ASC"}';
    } else {
      strUrl =
        this.getUrl() +
        "/clients/" +
        client_id +
        '/connections?filter={"include":{"relation":"userAuth","scope":{"fields":["gender","birth_date","answers"]}},"where":{"datetimeauto":{"between":["' +
        moment(start_date)
          .local()
          .format() +
        '", "' +
        moment(end_date)
          .local()
          .format() +
        '"]}},"order":"datetimeauto ASC"}';
    }

    return axios.get(strUrl);
  }

  getNewUserByClientIdDates(client_id, start_date, end_date) {
    var url = `${this.getUrlStaging()}/connection_count_2s/reportByDayNew/${client_id}/${start_date}/${end_date}`;

    // var new_limit = undefined;
    // var skip = undefined;
    // var strUrl = "";

    // strUrl =
    //   this.getUrl() +
    //   "/connection_counts/news_portal/" +
    //   client_id +
    //   "/" +
    //   start_date +
    //   "/" +
    //   end_date;

    return axios.get(url);
  }

  getConnectionsByClientIdDatesGroup(group, start_date, end_date) {
    var new_limit = undefined;
    var skip = undefined;
    var strUrl = "";

    strUrl =
      this.getUrl() +
      "/connection_counts/news_portal_group/" +
      group +
      "/" +
      start_date +
      "/" +
      end_date;
    return axios.get(strUrl);
  }

  getPersons(client_id, start_date, end_date) {
    var strUrl =
      this.getUrl() +
      "/clients/" +
      client_id +
      '/connections?filter={"fields":["mac_address"],"include":"userAuth","where":{"datetimeauto":{"between":["' +
      moment(start_date)
        .local()
        .format() +
      '", "' +
      moment(end_date)
        .local()
        .format() +
      '"]}},"order":"datetimeauto ASC"}';
    return axios.get(strUrl);
  }

  getConnections(client_id, start_date, end_date) {
    var strUrl =
      this.getUrl() +
      "/clients/" +
      client_id +
      '/connections?filter={"fields":["mac_address","ip","datetimeauto"],"where":{"datetimeauto":{"between":["' +
      moment(start_date)
        .local()
        .format() +
      '", "' +
      moment(end_date)
        .local()
        .format() +
      '"]}},"order":"datetimeauto ASC"}';

    return axios.get(strUrl);
  }

  getLeads(controllerId, start_date, end_date) {
    return axios.get(
      this.getUrl() +
        "/connections/getLeads/" +
        controllerId +
        "/" +
        start_date +
        "/" +
        end_date
    );
  }

  getOnlineByControllerIdAll(controller_id) {
    return axios.get(
      this.getUrl() +
        '/swarmStatus/findOne?filter={ "where": {"clientname":"' +
        controller_id +
        '"}}'
    );
  }
  getOnlineByControllerIdUsers(controller_id) {
    return new Promise(resolve => {
      axios
        .get(
          this.getUrl() +
            '/swarmStatus/findOne?filter={ "fields": "id", "where": {"clientname":"' +
            controller_id +
            '"}}'
        )
        .then(response => {
          axios
            .get(this.getUrl() + "/swarmStatus/" + response.data.id + "/users")
            .then(users => {
              resolve(users);
            });
        });
    });
  }
  saveSettings(userId, photo) {
    return axios.patch(`${this.getUrl()}/Users/${userId}`, {
      photo
    });
  }
  changePassword(oldPassword, newPassword) {
    var formData = "oldPassword=" + oldPassword + "&newPassword=" + newPassword;

    return axios.post(this.getUrl() + "/Users/change-password", formData);
  }

  saveTheme(userId, isDark) {
    return axios.patch(this.getUrl() + "/Users/" + userId, {
      theme: isDark
    });
  }

  getClientLogo(controller_id) {
    return axios.get(
      this.getUrl() +
        '/clients/findOne?filter={"where":{"controller_id":"' +
        controller_id +
        '"},"fields":"logo_base64"}'
    );
  }

  getClientFields(client_id) {
    return axios.get(
      this.getUrl() + "/clients/" + client_id + '?filter={"fields":["fields"]}'
    );
  }

  /* Vouchers */
  getVouchers(client_id) {
    return axios.get(
      this.getUrl() +
        '/vouchers?filter={"where":{"client_id":{"like":"' +
        client_id +
        '"}}}'
    );
  }

  saveVoucher(voucher) {
    return axios.post(this.getUrl() + "/vouchers", voucher);
  }

  deleteVoucher(voucher_id) {
    return axios.delete(this.getUrl() + "/vouchers/" + voucher_id);
  }

  saveLog(dust) {
    return axios.post(this.getUrl() + "/dust", dust);
  }

  updateVoucher(voucher) {
    return axios.put(this.getUrl() + "/vouchers/" + voucher.id, voucher);
  }

  getOnlineStatus(radioPrefix) {
    let response = axios.get(
      this.getUrl() +
        '/status_temps?filter={"where":{"clientname":"' +
        radioPrefix +
        '"},"limit":1,"order":"datetime  DESC"}'
    );

    if (response.data) {
      response = axios.get(
        this.getUrl() +
          '/status_temps?filter={"where":{"clientname":"' +
          radioPrefix.toLowerCase() +
          '"},"limit":1,"order":"datetime  DESC"}'
      );
    }
    return response;
  }

  getOnlineGroupStatus(radio_prefix_list, dateStart, dateEnd) {
    //:{"like":"sns","options":"i"}},
    return axios.get(
      this.getUrl() +
        '/status_temps?filter={"where":{"clientname":{"inq":[' +
        radio_prefix_list.toLowerCase() +
        ']}, "datetime":{"lte":"' +
        dateEnd +
        '", "gte":"' +
        dateStart +
        '"}},"order": "datetime ASC"}'
    );
  }

  getVagalumeStatus(radio_prefix, dateStart, dateEnd) {
    return axios.get(
      this.getUrlStaging() +
        '/vagalumeStatuses?filter={"where":{"radio_prefix":"' +
        radio_prefix +
        '", "datetime":{"between":["' +
        dateStart +
        '","' +
        dateEnd +
        '"]}},"order": "datetime ASC"}'
    );
  }

  getSummary(client_id, start_date, end_date) {
    var url = `${this.getUrlStaging()}/summaries/getPeriodSummary/${client_id}/${start_date}/${end_date}`;
    if (this.debug_ws)
      console.log("summary> ", url, " ", start_date, " ", end_date);
    return axios.get(url);
  }
  async getAuthenticated(client, start_date, end_date) {
    var url = `${this.getUrlStaging()}/connections/reportByDay/${client}/${start_date}/${end_date}`;
    if (this.debug_ws)
      console.log("summary> ", url, " ", start_date, " ", end_date);
    const response = await axios.get(url);

    return response.data;
  }

  deleteSummary(id_summary) {
    axios.delete(this.getUrlStaging() + "/summaries/" + id_summary);
  }

  getSummaryNps(client_id, start_date, end_date) {
    var url =
      this.getUrlStaging() +
      '/summaries_nps?filter={"where":{"controller_id":"' +
      client_id +
      '","and":[{"datetime": {"gte": "' +
      start_date +
      '"}},{"datetime": {"lte": "' +
      end_date +
      '"}}]}}';
    if (this.debug_ws)
      console.log("summary> ", url, " ", start_date, " ", end_date);
    return axios.get(url);
  }

  getGroupSummary(client_id_list, start_date, end_date) {
    var url = this.getUrlStaging() + "/summaries/acessos_grupo";
    return axios.post(url, {
      clients: client_id_list,
      start: start_date,
      end: end_date
    });
  }

  getSummaryQuestion(questionID) {
    return axios.get(
      this.getUrl() +
        '/summariesRedoneQuestion?filter={"where":{"questionID":{"like":"' +
        questionID +
        '"}}}'
    );
  }

  getSummaryQuestionsActive(client_id, start_date, end_date) {
    return axios.get(
      this.getUrl() +
        '/summariesRedoneQuestions?filter={"where":{"is_active":"true","client_id":{"like":"' +
        client_id +
        '"},"and":[{"date": {"gte": "' +
        start_date +
        '"}},{"date": {"lte": "' +
        end_date +
        '"}}]}}'
    );
  }

  postSummary(summary) {
    return axios.post(this.getUrlStaging() + "/summaries", summary);
  }

  postSummaryQuestion(summary) {
    return axios.post(this.getUrl() + "/summaryQuestions", summary);
  }

  getRadiosByRadioPrefix(radio_prefix) {
    if (radio_prefix.length < 4) {
      return axios.get(
        this.getUrlStaging() +
          '/radios?filter={"where":{"or":[{"clientname":"' +
          radio_prefix.toUpperCase() +
          '"},{"clientname":"' +
          radio_prefix.toLowerCase() +
          '"}]}}'
      );
    } else {
      return axios.get(
        this.getUrlStaging() +
          '/radios?filter={"where":{"clientname":{"regexp":"' +
          radio_prefix +
          '/gi"}}}'
      );
    }
  }
  getRadiosByRadioPrefix2(radio_prefix) {
    return axios.get(
      this.getUrlStaging() +
        '/radios?filter={"where":{"or":[{"clientname":"' +
        radio_prefix.toUpperCase() +
        '"},{"clientname":"' +
        radio_prefix.toLowerCase() +
        '"}]}}'
    );
  }
  deleteRadiosbyRadioPrefix(radio_id) {
    return axios.delete(this.getUrl() + "/radios/" + radio_id);
  }

  clearRadioHistoryById(radio) {
    let action = "clearRadioHistoryById";
    radio.historico = [
      {
        status: "online",
        date: Date.parse(new Date())
      }
    ];

    let payload = { radio: radio };
    let endpoint = `PATCH /radios/${radio.id}`;
    let status;

    let clientControllerId = JSON.parse(localStorage.getItem("data")).client
      .controller_id;

    try {
      var response = axios.patch(this.getUrl() + "/radios/" + radio.id, radio);
      status = { status: "success" };
      this.logInteraction(
        action,
        payload,
        endpoint,
        status,
        "",
        clientControllerId,
        ""
      );
      return response;
    } catch (e) {
      status = { status: "fail", detail: e };
      this.logInteraction(
        action,
        payload,
        endpoint,
        status,
        "",
        clientControllerId,
        ""
      );
    }
  }

  patchRadiosbyRadioPrefix(radio) {
    let action = "patchRadiosbyRadioPrefix";
    let payload = { radio: radio };
    let endpoint = `PATCH /radios/${radio.id}`;
    let status;

    let clientControllerId = JSON.parse(localStorage.getItem("data")).client
      .controller_id;

    try {
      var response = axios.patch(this.getUrl() + "/radios/" + radio.id, radio);
      status = { status: "success" };
      this.logInteraction(
        action,
        payload,
        endpoint,
        status,
        "",
        clientControllerId,
        ""
      );
      return response;
    } catch (e) {
      status = { status: "fail", detail: e };
      this.logInteraction(
        action,
        payload,
        endpoint,
        status,
        "",
        clientControllerId,
        ""
      );
    }
  }
  postRadiosbyRadioPrefix(radio) {
    let action = "postRadiosbyRadioPrefix";
    let payload = { radio: radio };
    let endpoint = `POST /radios/postRadios`;
    let status;

    let clientControllerId = JSON.parse(localStorage.getItem("data")).client
      .controller_id;

    try {
      var response = axios.post(this.getUrl() + "/radios/postRadios", radio);
      status = { status: "success" };
      this.logInteraction(
        action,
        payload,
        endpoint,
        status,
        "",
        clientControllerId,
        ""
      );
      return response;
    } catch (e) {
      status = { status: "fail", detail: e };
      this.logInteraction(
        action,
        payload,
        endpoint,
        status,
        "",
        clientControllerId,
        ""
      );
    }
  }
  getRadiosConnect(controller_id, datetime) {
    return axios.get(
      this.getUrl() +
        "/ap_connecteds/map_data/" +
        controller_id +
        "/" +
        datetime
    );
  }
  getRadiosConnectDay(radio_prefix, datetime) {
    return axios.get(
      this.getUrl() +
        "/ap_connecteds/map_data_day/" +
        radio_prefix +
        "/" +
        datetime
    );
  }
  getRadiosSensor(radio_prefix, datetime) {
    return axios.get(
      this.getUrl() + "/ap_sensors/map_data/" + radio_prefix + "/" + datetime
    );
  }
  getRadiosSensortDay(radio_prefix, datetime) {
    return axios.get(
      this.getUrl() +
        "/ap_sensors/map_data_day/" +
        radio_prefix +
        "/" +
        datetime
    );
  }

  //2020-05-01T03:00:00Z' --header 'Authorization: '
  getDailyFlow(idVagalox, datetime, floor) {
    //return [0,0,2651]
    var url =
      this.getUrl() + "/connections/day_flow/" + idVagalox + "/" + datetime;
    if (floor >= 0 && floor != 32) url += "/" + floor;
    else url += "/undefined";
    return axios.get(url);

    /*var url = "http://35.231.118.223:9090/report?"+
              "client="+
              idVagalox.replace(/-/gi, "_") +
              "&type=flow&period=day&datetime="+
              moment(datetime).local().format("YYYY-MM-DD")+"T03:00:00Z"



    //return axios.get(url, { headers: { Authorization: "Basic ZG06QGRtY2xpZW50Jg==" } })
    if(this.debug_ws) console.log("getDailyFlow: " + url)
    //return [42, 43, 44]*/
  }

  getHourlyFlow(idVagalox, datetime, floor) {
    var url =
      this.getUrl() + "/connections/hour_flow/" + idVagalox + "/" + datetime;
    if (floor >= 0 && floor != 32) url += "/" + floor;
    else url += "/undefined";

    return axios.get(url);
    /*var url = "http://35.231.118.223:9090/report?"+
              "client="+
              idVagalox.replace(/-/gi, "_") +
              "&type=flow&period=hour&datetime="+
              moment(datetime).local().format("YYYY-MM-DD[T]HH[:00:00Z]")


    if (floor >=0 ) url +="&floor="+ floor;
    //return axios.get(url, { headers: { Authorization: "Basic ZG06QGRtY2xpZW50Jg==" } })
    if(this.debug_ws) console.log("getDailyFlow: " + url)
    //return [42, 43, 44]*/
  }

  getUsersByQuestion(question_id, fields) {
    var fields_ = fields.slice(0).map(el => '"' + el.name + '"');
    var where =
      '"where":{"answers":{"elemMatch":{"question_id":"' + question_id + '"}}}';

    return axios.get(
      this.getUrl() +
        "/userAuths?filter={" +
        where +
        ',"fields":[' +
        fields_.join(",") +
        ',"answers"]}'
    );
  }

  getTotalSensored(idVagalox) {
    //?filter=%7B%22fields%22%3A%5B%22client%22%2C%20%20%22Total_Stations%22%2C%20%22ts%22%5D%7D
    var end_date = "2020-05-13T02:25:00.000Z";
    var start_date = moment(end_date).subtract(1, "days");

    var url =
      this.getUrl() +
      "/ap_sensors?client=" +
      idVagalox.replace(/-/gi, "_") +
      "&filter=" +
      '{"fields":["Total_Stations","ts"], "where":{"ts":{"between":["' +
      moment(start_date)
        .local()
        .format() +
      '", "' +
      moment(end_date)
        .local()
        .format() +
      '"]}},"limit":48,"order":"ts ASC"}';
    if (this.debug_ws) console.log(url);
    return axios.get(url);
  }

  getLastSensored(idVagalox) {
    //?filter=%7B%22fields%22%3A%5B%22client%22%2C%20%20%22Total_Stations%22%2C%20%22ts%22%5D%7D
    var url =
      this.getUrl() +
      "/ap_sensors?filter=" +
      '{"fields":["Total_Stations","ts"], "where":{"client":"' +
      idVagalox.replace(/-/gi, "_") +
      '"}, "limit":1,"order":"ts DESC"}';
    if (this.debug_ws) console.log(url);
    return axios.get(url);
  }
  getSensoredGraph(radio_prefix, dateEnd) {
    if (this.debug_ws)
      console.log("hora>>", moment(dateEnd).format("hh:mm:ss"));
    if (moment(dateEnd).format("hh:mm:ss") == "12:00:00")
      dateEnd = moment(dateEnd)
        .add(1, "day")
        .format();
    var url =
      this.getUrl() +
      "/ap_connecteds/map_graphic/" +
      radio_prefix +
      "/" +
      moment(dateEnd)
        .subtract(1, "day")
        .format() +
      "/" +
      dateEnd;
    if (this.debug_ws) console.log(url);
    return axios.get(url);
  }

  getTotalDevices(client) {
    let response = axios.get(
      this.getUrl() +
        "/status_temps?filter=" +
        '{"fields":["totaldevices"], "where":{"clientname":"' +
        client +
        '"}, "limit":1,"order":"datetime  DESC"}'
    );

    if (response.data.length == 0) {
      response = axios.get(
        this.getUrl() +
          "/status_temps?filter=" +
          '{"fields":["totaldevices"], "where":{"clientname":"' +
          client.toLowerCase() +
          '"}, "limit":1,"order":"datetime  DESC"}'
      );
    }

    return axios.get(url);
  }

  getNotifications(controller_id) {
    var url =
      this.getUrl() +
      "/vagalume_alarm_configs?filter=" +
      '{"where":{"controller_id":"' +
      controller_id +
      '"}}';
    if (this.debug_ws) console.log(url);
    return axios.get(url);
  }
  getNotificationConfigs(controller_id) {
    var url =
      this.getUrl() +
      "/client_rule_notifications?filter=" +
      '{"where":{"controller_id":"' +
      controller_id +
      '"}}';
    if (this.debug_ws) console.log(url);
    return axios.get(url);
  }

  saveNewNotificationRule(data) {
    return axios.post(this.getUrl() + "/vagalume_alarm_configs", data);
  }
  updateNotificationRule(data) {
    return axios.put(
      this.getUrl() + "/vagalume_alarm_configs/" + data.id,
      data
    );
  }
  updateNotificationSettings(data) {
    return axios.put(
      this.getUrl() + "/client_rule_notifications/" + data.id,
      data
    );
  }
  updateAccessToken(accessToken) {
    return axios.get(
      this.getUrl() + "/connections/att_access_token/" + accessToken
    );
  }

  async checkAccessToken(accessToken) {
    var response = await axios.get(
      this.getUrl() + "/connections/att_access_token/" + accessToken
    );

    if (response.status == 501 || response.status == 401) {
      return true;
    } else {
      return false;
    }
  }

  getActiveCampaigns(client_id) {
    return axios.get(
      this.getUrl() +
        "/videoManifests?filter=" +
        '{"fields":["end_date","start_date","view_data","show_qt", "mediaLink"],"where":{"is_active":"true","client_id":{"like":"' +
        client_id +
        '"}}}'
    );
  }

  //mudar para videomanifests -> mongo mas falta o show_qt que nao tem no
  getCampaigns(client_id) {
    return axios.get(
      this.getUrl() +
        "/videoManifests?filter=" +
        '{"where":{"client_id":{"like":"' +
        client_id +
        '"}}}'
    );
  }

  getApsByPeriod(controller_id, date_start, date_end) {
    return axios.get(
      this.getUrlStaging() +
        "/ap_connecteds/map_data_period/" +
        controller_id +
        "/" +
        date_start +
        "/" +
        date_end
    );
  }

  getClientID(controller_id) {
    return axios.get(
      this.getUrl() +
        "/clients?filter=%7B%22where%22%3A%7B%22controller_id%22%3A%22" +
        controller_id +
        "%22%7D%2C%22fields%22%3A%5B%22id%22%5D%7D"
    );
  }

  getEmailWelcome(clientID) {
    return axios.get(
      this.getUrlStaging() +
        "/emails?filter=%7B%22where%22%3A%7B%22clientID%22%3A%22" +
        clientID +
        "%22%7D%7D"
    );
  }
  postEmailWelcome(email) {
    return axios.post(this.getUrl() + "/emails", email);
  }
  putEmailWelcome(emailID, email) {
    return axios.put(this.getUrlStaging() + "/emails/" + emailID, email);
  }

  getEmailSettings(clientID) {
    return axios.get(
      this.getUrlStaging() +
        "/emailsSettings?filter=%7B%22where%22%3A%7B%22clientID%22%3A%22" +
        clientID +
        "%22%7D%7D"
    );
  }

  postEmailSettings(emailSettings) {
    return axios.post(this.getUrlStaging() + "/emailsSettings", emailSettings);
  }
  putEmailSettings(settingsID, emailSettings) {
    return axios.put(
      this.getUrlStaging() + "/emailsSettings/" + settingsID,
      emailSettings
    );
  }
  getEmailsSent(emailID) {
    return axios.get(
      this.getUrlStaging() +
        "/sentMails?filter=%7B%22where%22%3A%7B%22emailID%22%3A%20" +
        emailID +
        "%7D%7D"
    );
  }

  getSms(clientID) {
    return axios.get(
      this.getUrlStaging() +
        "/smsS?filter=%7B%22where%22%3A%7B%22clientID%22%3A%22" +
        clientID +
        "%22%7D%7D"
    );
  }

  postSms(sms) {
    return axios.post(this.getUrlStaging() + "/smsS", sms);
  }

  putSms(smsID, sms) {
    return axios.put(this.getUrlStaging() + "/smsS/" + smsID, sms);
  }

  getSmsSent(smsID) {
    return axios.get(
      this.getUrlStaging() +
        "/sentSmsS?filter=%7B%22where%22%3A%7B%22smsID%22%3A" +
        smsID +
        "%7D%7D"
    );
  }

  getRedoneQuestion(clientID) {
    return axios.get(
      this.getUrlStaging() +
        "/redoneQuestions?filter=%7B%22where%22%3A%7B%22clientID%22%3A%22" +
        clientID +
        "%22%7D%7D"
    );
  }

  getDataByRecurrence(controller_id, startDate, endDate) {
    return axios.get(
      this.getUrl() +
        "/dataAnalyses/?filter=" +
        '{"where": {"controller_id":"' +
        controller_id +
        '", "startDate":{"gt":"' +
        startDate +
        '"},' +
        '"endDate":{"lt":"' +
        endDate +
        '"}}}'
    );
  }

  async logInteraction(
    action,
    payload,
    endpoint,
    status,
    mac,
    controller_id,
    queryString,
    firstRequest = false
  ) {
    let usage_log = {
      ts: new Date(),
      mac: mac,
      action: action,
      controller_id: controller_id,
      payload: JSON.stringify(payload),
      endpoint: endpoint,
      status: JSON.stringify(status),
      queryString: queryString
    };

    let resp = await axios.post(`${this.getUrl()}/captive-logs`, usage_log);
    if (firstRequest) this.queryString = resp.data.id;
  }

  //"client_id":"guararapes"}}
  //videoManifestspg?filter={"fields":["end_date","view_data","show_qt"],"where":{"is_active":true,"client_id":"guararapes"}}
  /*
        {
        "controller_id": "guararapes",
        "email": true,
        "sms": false,
        "email_list": [
          "jwmrf@cin.ufpe.br",
          "julio.freire@elcoma.com.br"
        ],
        "sms_list": [
          "string"
        ],
        "interval_notification": 300,
        "receive_ap_crowding": true,
        "datetime": null,
        "id": 3
      }
     */
}

// {
//   "fields":[
//       "client", "Total_Stations", "ts"
//   ],
//   "where":{
//     "datetimeauto":{
//       "between":["2020-05-13", "2020-05-12""]
//     }
//   }

//   {"fields":[  "Total_Stations", "ts"], "where":{"client":"boulevard_londrina_shopping""ts":{"between":["2020-05-12", "2020-05-13"]}},"limit":48,"order":"ts ASC"}
//   {"fields":["client",  "Total_Stations", "ts"], "where":{"datetimeauto":{"between":["2020-05-13", "2020-05-12"]}},"limit":48,"order":"datetimeauto ASC"}



// WEBPACK FOOTER //
// ./src/Webservices.js